import { RefObject, useLayoutEffect, useState } from 'react';
import useResizeObserver from '@react-hook/resize-observer';

export function useWidth(target: RefObject<HTMLDivElement>) {
  const [width, setWidth] = useState<number>();

  useLayoutEffect(() => {
    if (target.current) {
      setWidth(target.current.getBoundingClientRect().width);
    }
  }, [target]);

  useResizeObserver(target, (entry) => setWidth(entry.contentRect.width));

  return width;
}
